import firebase from "firebase/app";
import database from 'firebase/database';
import 'firebase/auth';

const config = {
    apiKey: "AIzaSyC_QXxiHay3ceeSceSEbx0gCpAeKBIzgd4",
    authDomain: "react-firebase-blog-291d4.firebaseapp.com",
    databaseURL: "https://react-firebase-blog-291d4-default-rtdb.firebaseio.com",
    projectId: "react-firebase-blog-291d4",
    storageBucket: "react-firebase-blog-291d4.appspot.com",
    messagingSenderId: "56496362352",
    appId: "1:56496362352:web:9b87c50518de62df9975b5"
};

let firebaseCache;

export const getFirebase = () => {
    if (firebaseCache) {
        return firebaseCache;
    }

    firebase.initializeApp(config);
    firebaseCache = firebase;
    return firebase;
};
